module.exports = __webpack_public_path__ + "img/liked.5d17824.gif";